export const vatOptions = ['Exportation', 'Formation', 'Exempt', 'Swiss VAT'];
